// Helper utilities for Dream Rate (Pending Subscriptions)

export type PendingSubscriptionStatusId =
  | "active"
  | "pending"
  | "cancelled"
  | "delete"

type PendingLike = {
  deleted?: string | number | boolean
  status?: string | number
  converted_at?: string | number | null
}

// Derive a normalized status id for pending subscriptions
// Rules:
// - deleted === "1" => "delete"
// - status == 0 and has converted_at => "active"
// - status == 0 => "pending"
// - otherwise => "cancelled"
export function getPendingSubscriptionStatus(
  info: PendingLike
): PendingSubscriptionStatusId {
  const deletedFlag =
    info.deleted === "1" || info.deleted === 1 || info.deleted === true

  if (deletedFlag) return "delete"

  const statusStr = info.status?.toString()
  const hasConverted = !!info.converted_at

  if (statusStr === "0" && hasConverted) return "active"
  if (statusStr === "0") return "pending"
  return "cancelled"
}
